module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "form",
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgrid),
      expression: "showgrid"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "title": '<h5>Ir para Metas</h5>',
      "type": "button"
    },
    on: {
      "click": _vm.irMetas
    }
  }, [_c('i', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "small"
    }
  }, [_vm._v(" Metas")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "title": '<h5>Ir para Atividades</h5>',
      "type": "button"
    },
    on: {
      "click": _vm.irAtividades
    }
  }, [_c('i', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "small"
    }
  }, [_vm._v(" Atividades")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table.filter),
      expression: "table.filter"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.table, "filter", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "disabled": _vm.contador === 0,
      "title": '<h5>Salvar</h5>',
      "type": "button"
    },
    on: {
      "click": _vm.salvar
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "small"
    }
  }, [_vm._v(" Salvar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "title": '<h5>Novo registro</h5>',
      "type": "button"
    },
    on: {
      "click": [function($event) {
        _vm.showgrid = !_vm.showgrid
      }, function($event) {
        $event.stopPropagation();
        return _vm.onNew($event)
      }]
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "small"
    }
  }, [_vm._v(" Novo registro")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "tabelaAlteracao",
    attrs: {
      "id": "tabelaAlteracao",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "row-clicked": _vm.linha
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', [(!_vm.temId(row.item.detalhamento)) ? _c('div', [_c('button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")])]) : _vm._e()])]
      }
    }, {
      key: "tipo",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(row.value.descricao))])]
      }
    }, {
      key: "motivo",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(row.value.descricao))])]
      }
    }, {
      key: "responsavel.ds_nome_usuario",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(row.value))])]
      }
    }, {
      key: "documentos",
      fn: function(row) {
        return [(row.item.documentos.length > 0) ? _c('i', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
          }],
          staticClass: "glyphicon glyphicon-duplicate",
          staticStyle: {
            "font-size": "large"
          },
          attrs: {
            "title": '<h5>Existe(m) ' + '<b>' + row.item.documentos.length + '</b>' + ' documento(s) em anexo. Clique em editar para visualizar o(s) documento(s).</h5>',
            "aria-en": "true"
          }
        }) : _vm._e()]
      }
    }, {
      key: "detalhamento",
      fn: function(row) {
        return [(_vm.temId(row.item.detalhamento)) ? _c('span', {
          staticClass: "grupoMostrarOcultar",
          on: {
            "click": function($event) {
              _vm.abrirLink('/solicitacao/alteracoesprojeto/' + _vm.temId(row.item.detalhamento), true)
            }
          }
        }, [_vm._v(_vm._s(_vm.temId(row.item.detalhamento)) + " "), _c('i', {
          staticClass: "fa fa-external-link"
        })]) : _vm._e(), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s((row.item.detalhamento).replace('#' + _vm.temId(row.item.detalhamento) + '# ', ''))
          }
        })]
      }
    }, {
      key: "dt_registro",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "prazo",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "id_processo",
      fn: function(row) {
        return [_c('div', {
          staticClass: "linkProcesso"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'solicitacao-alteracoes-projeto-visualizacao',
              params: {
                id: row.value
              }
            }
          }
        }, [_vm._v(_vm._s(row.value))])], 1)]
      }
    }], null, false, 2460787272)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1)], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "form-horizontal row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "name": "frmAddAt"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('data')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "data"
    }
  }, [_vm._v("Data:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.alteracao.id) ? _c('div', [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "data",
    attrs: {
      "name": "data",
      "input-class": "form-control",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "placeholder": "__ /__ /____",
      "highlighted": _vm.highlighted,
      "disabled": _vm.alteracao.id,
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.alteracao.dt_registro),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "dt_registro", $$v)
      },
      expression: "alteracao.dt_registro"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.alteracao.id) ? _c('div', [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "data",
    attrs: {
      "name": "data",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "placeholder": "__ /__ /____",
      "highlighted": _vm.highlighted,
      "disabled": _vm.alteracao.id,
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.alteracao.dt_registro),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "dt_registro", $$v)
      },
      expression: "alteracao.dt_registro"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.errors.first('data')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tipo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "tipo"
    }
  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.tipos,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um Tipo de Alteração",
      "track-by": "codigo",
      "custom-label": _vm.etiquetaTipos,
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "tipo",
      "disabled": _vm.alteracao.id,
      "data-vv-as": "Tipo de alteração"
    },
    on: {
      "select": function($event) {
        return _vm.onSelect($event, _vm.alteracao.tipo)
      }
    },
    model: {
      value: (_vm.alteracao.tipo),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "tipo", $$v)
      },
      expression: "alteracao.tipo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('tipo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "detalhamentoBloq"
    }
  }, [_vm._v("Histórico Detalhe:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('font', {
    domProps: {
      "innerHTML": _vm._s(_vm.alteracao.detalhamento)
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('detalhamento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "detalhamento"
    }
  }, [_vm._v("Detalhe:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detalhamentoAnt),
      expression: "detalhamentoAnt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.place,
      "name": "detalhamento",
      "type": "text",
      "maxlength": "1000",
      "cols": "10",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.detalhamentoAnt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detalhamentoAnt = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('detalhamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('detalhamento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('motivo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "motivo"
    }
  }, [_vm._v("Motivo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.motivos,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um Motivo",
      "track-by": "codigo",
      "custom-label": _vm.etiquetaMotivos,
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "tipo",
      "data-vv-as": "Motivo da alteração",
      "disabled": _vm.prorrogacaoEdit
    },
    model: {
      value: (_vm.alteracao.motivo),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "motivo", $$v)
      },
      expression: "alteracao.motivo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('motivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo')))]) : _vm._e()]), _vm._v(" "), (_vm.alteracao.responsavel.ds_nome_usuario) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "responsavel"
    }
  }, [_vm._v("Responsável:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alteracao.responsavel.ds_nome_usuario),
      expression: "alteracao.responsavel.ds_nome_usuario"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "responsavel",
      "type": "text",
      "maxlength": "255",
      "disabled": true
    },
    domProps: {
      "value": (_vm.alteracao.responsavel.ds_nome_usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.alteracao.responsavel, "ds_nome_usuario", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "responsavel"
    }
  }, [_vm._v("Anexos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.alteracao.documentos,
      "documentTypes": '',
      "disable": '',
      "localUso": 'TODOS',
      "salvouOK": _vm.salvouOK,
      "editandoAlteracaoProjeto": _vm.editandoItem,
      "editandoProrrogacao": _vm.prorrogacaoEdit
    }
  })], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onAdd(_vm.frmAddAt)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onCancel(_vm.frmAddAt)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])], 1)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d594c71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/alteracoesProjetos.vue
// module id = 2002
// module chunks = 1